module.exports = __webpack_public_path__ + "static/media/building1.0c79eed6.png";